import "./style.css"

function MediaDetailsContainer({
    media,
    details,
    className
}) {
    return (
        <div id="custom-details-area-wrapper" className={className}>
            <div id="custom-details-area">
                <div id="cda-media-container">
                    {media}
                </div>
                <div id="cda-media-detail">
                    <div>
                        {details}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MediaDetailsContainer;